import { useCallback, useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Button } from "../Button/Button";
import "./SharePage.scss";

export const SharePage = ({ faceBookLink, twitterLink, ...props }) => {
	const copyIcon = useRef(<i className="fa-regular fa-copy"></i>);
	const succesIcon = useRef(<i className="fa-regular fa-check"></i>);
	const [copyButtonIcon, setCopyButtonIcon] = useState(copyIcon.current);

	let showLinkedIn = props.showLinkedIn ?  props.showLinkedIn : false; 

	//Function that returns current url
	const directLink = () => {
		try {
			if (window) {
				return window.location.href;
			}
		} catch (error) {
			return "";
		}
	};

	const openFbShare = () => {
		window
			.open(
				"https://www.facebook.com/sharer/sharer.php?u=" +
					directLink(),
				"_blank"
			)
			.focus();
	};

	const copyToClipboard = (textToCopy) => {
		// navigator clipboard api needs a secure context (https)
		if (navigator && navigator.clipboard && window.isSecureContext) {
			// navigator clipboard api method'
			return navigator.clipboard.writeText(textToCopy);
		} else {
			// text area method
			let textArea = document.createElement("textarea");
			textArea.value = textToCopy;
			// make the textarea out of viewport
			textArea.style.position = "fixed";
			textArea.style.left = "-999999px";
			textArea.style.top = "-999999px";
			document.body.appendChild(textArea);
			textArea.focus();
			textArea.select();
			return new Promise((res, rej) => {
				// here the magic happens
				document.execCommand("copy") ? res() : rej();
				textArea.remove();
			});
		}
	};

	const openTwitterShare = () => {
		window
			.open(
				`https://twitter.com/share?text=${(props.shareTitle ? props.shareTitle : "")}&url=${directLink()}`,
				"_blank"
			)
			.focus();
	};

	const openLinkedInShare = () => {
		window
			.open(
				"https://www.linkedin.com/sharing/share-offsite/?url=" +
					directLink(),
				"_blank"
			)
			.focus();
	};

	return (
		<div>
			<div className="c-section-wrap">
				<div className="c-section-share">
					<div className="c-section-share__header">
						<h5 className="title">Deel deze pagina:</h5>
					</div>
					<div className="c-section-share-items">
						<Button
							buttonType={"secondary"}
							isIcon={true}
							icon={copyButtonIcon}
							onClick={() => {
								copyToClipboard(directLink());
								setCopyButtonIcon(succesIcon.current);
								setTimeout(() => {
									setCopyButtonIcon(copyIcon.current);
								}, 2000);
							}}
							label="link-share"
							title="Kopieer link"
						/>
						<Button
							buttonType={"secondary"}
							isIcon={true}
							icon={<i className="fa-brands fa-facebook-f"></i>}
							onClick={() => openFbShare()}
							label="facebook-share"
							title="Deel op facebook"
						/>
						<Button
							buttonType={"secondary"}
							isIcon={true}
							icon={<i className="fa-brands fa-x-twitter"></i>}
							onClick={() => openTwitterShare()}
							label="twitter-share"
							title="Deel op Twitter"
						/>
						{
							showLinkedIn ? 
							<Button
								buttonType={"secondary"}
								isIcon={true}
								icon={<i className="fa-brands fa-linkedin"></i>}
								onClick={() => openLinkedInShare()}
								label="linkedIn-share"
								title="Deel op LinkedIn"
							/>
							: null
						}
						
					</div>
				</div>
			</div>
		</div>
	);
};
